export const AUTH_CONFIG = {
  domain: process.env.REACT_APP_DOMAIN
}

export const APP_CONFIG = {
  baseURL: process.env.REACT_APP_BASEURL,
  azureStorageAccount: process.env.REACT_APP_AZURE_STORAGE_ACCOUNT,
  maxFileUploadSize: process.env.REACT_APP_FILE_UPLOAD_MAX_SIZE,
  reCaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  deviceLockEnabled: process.env.REACT_APP_DEVICE_LOCK_ENABLED !== 'false'
}
